import { render, staticRenderFns } from "./ArticlesSection.vue?vue&type=template&id=6680e4ae&scoped=true"
import script from "./ArticlesSection.vue?vue&type=script&lang=js"
export * from "./ArticlesSection.vue?vue&type=script&lang=js"
import style0 from "./ArticlesSection.vue?vue&type=style&index=0&id=6680e4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6680e4ae",
  null
  
)

export default component.exports